export class WorkspaceBucketPolicy {
    'policyDocument';
    'updatedAt';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "policyDocument",
            "baseName": "policyDocument",
            "type": "string",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceBucketPolicy.attributeTypeMap;
    }
    constructor() {
    }
}
